import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';

import store from 'store';
import theme from 'themes';

export default class Portal extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    content: PropTypes.element.isRequired
  };

  render = () => null;
  portalRoot = null;
  el = document.createElement('div');

  componentDidMount = () => {
    const { id } = this.props;
    let p = id && document.getElementById(id);
    if (!p) {
      p = document.createElement('div');
      p.id = id;
      if (document.body) {
        document.body.appendChild(p);
      }
    }
    this.portalRoot = p;
    p.appendChild(this.el);
    this.componentDidUpdate();
  };

  componentWillUnmount = () => {
    try {
      if (this.el) {
        ReactDOM.unmountComponentAtNode(this.el);
        if (this.portalRoot && this.el.parentNode === this.portalRoot) {
          this.portalRoot.removeChild(this.el);
        }
        if (
          this.portalRoot &&
          this.portalRoot.parentNode &&
          this.portalRoot.childNodes.length === 0
        ) {
          this.portalRoot.parentNode.removeChild(this.portalRoot);
        }
      }
    } catch (err) {
      console.warn('Portal cleanup warning:', err);
    }
  };

  componentDidUpdate = () => {
    const { content } = this.props;
    ReactDOM.render(
      <Provider store={store}>
        <ThemeProvider theme={theme}>{content}</ThemeProvider>
      </Provider>,
      this.el
    );
  };
}
